export const LIBOR_FORWARD_CURVE = "libor";
export const LIBOR_THREE_MONTH_FORWARD_CURVE = "liborThreeMonth";
export const LIBOR_SIX_MONTH_FORWARD_CURVE = "liborSixMonth";
export const LIBOR_TWELVE_MONTH_FORWARD_CURVE = "liborTwelveMonth";
export const THIRTY_DAY_AVG_SOFR_FORWARD_CURVE = "thirtyDayAvgSofr";
export const OVERNIGHT_SOFR_FORWARD_CURVE = "sofr";
export const FED_FUNDS_FORWARD_CURVE = "fedFunds";
export const SIFMA_FORWARD_CURVE = "sifma";
export const PRIME_FORWARD_CURVE = "prime";
export const CAP_VOLS = "capVolsCurve";
export const TREASURIES = "interpolateTreasuriesYieldCurve";
export const SEMIBOND = "interpolateSemibondYieldCurve";

export const MARKET_EXPECTATIONS_SHOCK = "MARKET_EXPECTATIONS";
export const PARALLEL_SHOCK = "PARALLEL";
export const STANDARD_DEVIATION_SHOCK = "STANDARD_DEVIATION";

export const TREASURY = "treasury";
export const SEMIBOND_SWAPS = "semiBondSwaps";
export const INTERNALLY_FIXED = "internallyFixed";

export const TREASURY_YEAR_TYPE = {
  TEASURY_Y1: "TREASURY Y1",
  TEASURY_Y2: "TREASURY Y2",
  TEASURY_Y3: "TREASURY Y3",
  TEASURY_Y5: "TREASURY Y5",
  TEASURY_Y7: "TREASURY Y7",
  TEASURY_Y10: "TREASURY Y10",
  TEASURY_Y20: "TREASURY Y20",
  TEASURY_Y30: "TREASURY Y30",
  TBILL_2ND_M3: "TBILL 2ND M3",
  TBILL_2ND_W4: "TBILL 2ND W4",
  TBILL_2ND_M6: "TBILL 2ND M6"
};

export const BASE_POINTS_DIVISOR = 10000;
